import { UsersActions, UsersActionTypes } from '@clients/ngrx/actions/users.actions';
import { ConfigService } from '@config/config.service';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { PaginationModel } from '@shared/models/pagination.model';
import {UserListModel} from "@services/back-office/model/userListModel";
import {UserListSearchRequest} from "@services/back-office/model/userListSearchRequest";

export const adapter: EntityAdapter<UserListModel> = createEntityAdapter<UserListModel>();

export interface State extends EntityState<UserListModel> {
  loading: boolean,
  pagination: PaginationModel,
  filter: UserListSearchRequest,
}

export const initialState: State = adapter.getInitialState({
  loading: false,
  pagination: {
    first: true,
    last: false,
    number: 0,
    numberOfElements: 0,
    size: new ConfigService().paginationConfig.pageSize,
    totalElements: 0,
  },
  filter: {},
});

export function reducer(state = initialState, action: UsersActions): State {
  switch (action.type) {
    /** Load Users */
    case UsersActionTypes.LoadUsers:
      return {...state, loading: !action.payload?.dontShowLoading};

    case UsersActionTypes.LoadUsersSuccess:
      return adapter.setAll(action.payload.content!, {
        ...state,
        loading: false,
        pagination: {
          size: action.payload.size,
          last: action.payload.last,
          totalElements: action.payload.totalElements,
          numberOfElements: action.payload.numberOfElements,
          first: action.payload.first,
          number: action.payload.number,
        },
      });

    case UsersActionTypes.LoadUsersFailure:
      return {...state, loading: false};

    /** Change User's Status */
    case UsersActionTypes.ChangeUsersStatus:
      return {...state};

    case UsersActionTypes.ChangeUsersStatusSuccess:
      return adapter.updateOne({
        id: action.payload.id!,
        changes: action.payload.user!,
      }, {...state});


    case UsersActionTypes.ChangeUsersStatusFailure:
      return {...state};

    /** Change Page */
    case UsersActionTypes.ChangePage:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          number: action.payload.number,
          size: action.payload.size,
        }
      };

    /** Set Initial Pagination */
    case UsersActionTypes.SetInitialPagination:
      return {...state, pagination: initialState.pagination};

    /** Set Filter */
    case UsersActionTypes.SetFilter:
      return {...state, filter: action.payload};

    /** Clear Filter */
    case UsersActionTypes.ClearFilter:
      return {...state, filter: initialState.filter};

    /** Set Initial State */
    case UsersActionTypes.SetInitialState:
      return {...initialState};

    default:
      return state;
  }
}

export const {
  selectIds: selectUsersIds,
  selectEntities: selectUsersEntities,
  selectAll: selectAllUsers,
  selectTotal: selectUsersTotal,
} = adapter.getSelectors();
